// Important Note: Here for switch 0 is ON and 1 is OFF

import React, { useEffect, useState } from "react";
import DataTable from "../../DRM/components/DataTable";
import Switch from "react-switch";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setMappedRules, setActiveFiles } from "../../../redux/actions/DRM_files.action";
import { setLoading } from "../../../redux/actions/DRM_user.action";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Tab, CircularProgress } from "@mui/material";
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import { axios_tenant } from "../../../../axios";
import CustomDialog from "../components/CustomDialog";
import AuditResultCard from "../components/AuditResultCard";
import { InfoOutlined } from "@mui/icons-material";
import { useCategory } from "../components/IpProvider";
import PropTypes from "prop-types";

const CustomNoRowsOverlay = () => {
		return (
			// <div style={{ textAlign: "center" }}>
			<Box sx={{
				display: 'flex', justifyContent: 'center',
				alignItems: 'center', margin: 2,
				fontSize: "20px"
			}}
			>
				There are no items to show
			</Box>
			// </div>
		)
	}
const MappedRules = ({ setActiveTab: setIpActiveTab }) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const mappedRules = useSelector((state) => state.fileStore.mappedRules);
	const activeFiles = useSelector((state) => state.fileStore.activeFiles);
	const [resultLoading, setResultLoading] = useState(false);

	const { category, switchCategory } = useCategory()

	const loading = useSelector((state) => state.userStore.loading);


	const [switchLoadingId, setSwitchLoadingId] = useState(null);

	const [filteredArray, setFilteredArray] = useState({
		all: [],
		bibliographic: [],
		activity: [],
		deadline: [],
		pair: [],
	});

	// Counts
	const [total, setTotal] = useState({
		all: 0,
		bibliographic: 0,
		activity: 0,
		deadline: 0,
		pair: 0,
	});

	const [showResultDialogueBox, setShowResultDialogueBox] = useState(false);
	const [total_added, setTotal_added] = useState(0);
	const [total_duplicate, setTotal_duplicate] = useState(0);
	const [total_ignored, setTotal_ignored] = useState(0);
	const [deleted_duplicate, setDeleted_duplicate] = useState(0);
	const [total_new_errors, setTotal_new_errors] = useState(0);
	const [dialogOpen, setDialogOpen] = useState(false);
	const [dialogProps, setDialogProps] = useState({});
	const [switchToTm, setSwitchToTm] = useState(false)
	const allFiles = ["WorkingStmtPA", "OpenDocketPA", "IndiaMattersPA", "ClosedDocketPA", "BibliographicPA", "PAIRPA"];
	const allFilesTM = ["BibliographicTM", "ClosedDocketTM"]
	const [uploadPending, setUploadPending] = useState(false);


	useEffect(() => {
		getMappedRules();
		if (activeFiles?.some((obj) => obj.status == "Pending")) {
			setUploadPending(true);
		} else {
			setUploadPending(false);
		}
	}, [category]);

	const getMappedRules = async () => {
		dispatch(setLoading(true));

		let response = await axios_tenant.get(`/drm/fetchMappedRules?category=${category}`);


		if (response?.status === 200) {
			let rules = response.data.data.mappedRules;
			dispatch(setMappedRules(rules));

			setTotal({
				all: rules.length,
				bibliographic: rules.filter((obj) => obj.rule_category === "Bibliographic").length,
				activity: rules.filter((obj) => obj.rule_category === "Activity").length,
				deadline: rules.filter((obj) => obj.rule_category === "Deadline").length,
				pair: rules.filter((obj) => obj.rule_category === "Pair").length,
			});

			handleFilteredArray(response.data.data.mappedRules);

			dispatch(setLoading(false));
		}
	};

	const handleFilteredArray = (rules) => {

		let map = new Map();

		rules = rules.filter((obj) => {
			if (map.has(obj.rule_name + obj.input_file_name)) {
				let arr = map.get(obj.rule_name + obj.input_file_name);
				arr.push(obj.id);
				map.set(obj.rule_name + obj.input_file_name, arr);
				return false;
			}
			else {
				let arr = [obj.id];
				map.set(obj.rule_name + obj.input_file_name, arr);
				return true;
			}
		});

		rules.forEach((obj) => {
			obj.arr = map.get(obj.rule_name + obj.input_file_name);
			obj.file_size = obj.input_file_name.split(";").length;
		})

		setFilteredArray({
			all: rules,
			bibliographic: rules.filter((obj) => obj.rule_category === "Bibliographic"),
			activity: rules.filter((obj) => obj.rule_category === "Activity"),
			deadline: rules.filter((obj) => obj.rule_category === "Deadline"),
			pair: rules.filter((obj) => obj.rule_category === "Pair"),
		});
	};
	const handleSwitch = async (row) => {
		setSwitchLoadingId(row.id);
		row.arr.forEach(async (id) => {
			let req = {
				id: String(id),
				status: !row.status,
			};
			await axios_tenant.post(`/drm/updateMapRule?category=${category}`, req).then((res) => res.data);
			await getMappedRules();
		})
		setSwitchLoadingId(null);
	};

	const columns = [
		{
			headerName: "Rule Name",
			// field: "rule_name",
			renderCell: ({ row }) => <div><span>{row.rule_name} </span> <span>({row.arr.length})</span></div>,
			selector: (row) => row.rule_name,
			sortable: true,
			flex: 1,
		},
		{
			headerName: "Status",
			field: "status",
			renderCell: ({ row }) => (
				<div className="">
					{/* <div className="on">ON</div> */}
					<Switch
						onChange={() => {
							handleSwitch(row);
						}}
						checked={row.status}
						onColor="#d9d9d9"
						onHandleColor="#383a87"
						offColor="#d9d9d9"
						offHandleColor="#676767"
						handleDiameter={16}
						uncheckedIcon={false}
						checkedIcon={false}
						height={11}
						width={32}
					/>
					{/* <div className="off">OFF</div> */}
					<div className="ml-2">{switchLoadingId && switchLoadingId == row.id ? <CircularProgress size={16} /> : null}</div>
				</div>
			),
			// width: "200",
			flex: 0.5,
		},
		{
			headerName: "Input File Name",
			field: "input_file_name",
			renderCell: ({ row }) => <span>{row.input_file_name.replace(/;/g, ',')}</span>,
			// selector: row.input_file_name,
			sortable: true,
			// width: "200",
			flex: 2,
		},
	];

	const checkMissingFiles = (pending, content) => {
		return new Promise((resolve, reject) => {

			setDialogProps({
				heading: "Missing Files",
				text: content,
				button1Text: 'Run Anyway',
				button2Text: 'Cancel',
				onButton1Click: () => resolve(true),
				onButton2Click: () => resolve(false),
			});
			setDialogOpen(true);
		});
	};

	const cancelUploadDialog = () => {
		return new Promise((resolve, reject) => {
			setDialogProps({
				heading: "Cancel Audit",
				text: "Do you want to cancel Audit and delete uploaded files?",
				button1Text: 'Cancel Audit',
				button2Text: 'Go Back',
				onButton1Click: () => resolve(true),
				onButton2Click: () => resolve(false),
			});
			setDialogOpen(true);
		});
	};
	const canRunDirectly = (pending) => {
		if (category === "patent") {
			return activeFiles.length === 6 && !pending;
		}

		if (category === "trademark") {
			return (
				
				activeFiles.some(
					file =>
						file.name === "ClosedDocketTM" &&
						file.name === "BibliographicTM"
				) && !pending
			);
		}

		return false;
	};
    const getMissingFiles = (activeFileSet) => {
		if (category === "patent") {
			if (
				activeFileSet.has("BibliographicTM") ||
				activeFileSet.has("ClosedDocketTM")
			) {
				setSwitchToTm(true);
			}

			return allFiles.filter(file => !activeFileSet.has(file));
		}

		setSwitchToTm(false);

		return allFilesTM.filter(file => !activeFileSet.has(file));
	};
	const validateFiles = async (pending) => {
		if (canRunDirectly(pending)) {
			return true;
		}

		const activeFileSet = new Set(
			activeFiles.map(file => file.file_name)
		);

		const missingFiles = getMissingFiles(activeFileSet);

		if (!missingFiles.length) {
			return true;
		}

		const content = pending
			? "File uploading is in progress."
			: `Following Files are Missing: ${missingFiles.join(", ")}`;

		return await checkMissingFiles(pending, content);
	};
	const updateAuditResult = (result) => {
		setTotal_added(result.total_added);
		setTotal_duplicate(result.total_duplicate);
		setTotal_ignored(result.total_ignored);
		setDeleted_duplicate(result.deleted_duplicates);

		setTotal_new_errors(
			result.total_added -
			result.deleted_duplicates -
			result.total_ignored
		);

		setShowResultDialogueBox(true);
	};
	const runFiles = async () => {
		const pending = activeFiles.some(file => file.status !== "Pass");

		const canContinue = await validateFiles(pending);

		if (!canContinue) {
			return;
		}

		setResultLoading(true);

		const response = await axios_tenant.get(
			`/drm/runActiveRules?category=${category}`
		);

		if (response?.status === 200) {
			if (response.data.trademark) {
				updateAuditResult(response.data.trademark);
			}

			if (response.data.patent) {
				updateAuditResult(response.data.patent);
			}

			setResultLoading(false);
			dispatch(setActiveFiles([]));
		}
	};

	const cancelFiles = async () => {
		if (activeFiles?.length != 6) {
			let confirmCancel = await cancelUploadDialog();
			// stopUploadDialogue
			if (!confirmCancel) {
				return;
			}
		}

		let response = await axios_tenant.get("/drm/cancelActiveRules").then((res) => res.data);

		if (response?.success) {
			dispatch(setActiveFiles([]));
			navigate("/drm/audit-result");
		}
	};





	const [value, setValue] = React.useState('all');
	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	return (
		<div>
			<TabContext value={value}>
				<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
					<TabList onChange={handleChange} aria-label="lab API tabs example">
						<Tab label={`All (${total.all})`} value="all" />
						<Tab label={`Bibliographic (${total.bibliographic})`} value="bibliographic" />
						<Tab label={`Activity (${total.activity})`} value="activity" />
						<Tab label={`Deadline (${total.deadline})`} value="deadline" />
						<Tab label={`PAIR (${total.pair})`} value="pair" />
					</TabList>
					{/* </Tabs> */}
				</Box>
				<Box sx={{ marginTop: 2 }}>
					<DataTable columns={columns}
						showToolbar={false}
						data={filteredArray[value]}
						loading={loading}
						noRowsOverlay={CustomNoRowsOverlay}
						noDataComponent={loading ? "Fetching data... " : "There are no items to show"} />
				</Box>
			</TabContext>


			{mappedRules.length ? (
				<Box sx={{ display: 'flex', justifyContent: 'flex-end', m: 2 }}>
					<Button variant="outlined" sx={{ mx: 1 }} onClick={() => cancelFiles()}>
						Cancel
					</Button>
					<Button variant="contained" disabled={uploadPending} onClick={() => runFiles()}>
						Run
					</Button>
				</Box>
			) : null}

			{resultLoading ? (
				<Box
					sx={{
						position: 'fixed',
						zIndex: 9999,
						top: "0",
						left: "0",
						right: "0",
						bottom: "0",
						backgroundColor: "rgba(0,0,0,0.5)",
					}}
				>
					<CircularProgress sx={{ position: 'absolute', top: "50%", left: "50%" }} />
				</Box>
			) :

				<Dialog
					open={showResultDialogueBox}
					onClose={() => setShowResultDialogueBox(false)}
					aria-labelledby="alert-dialog-title"
					aria-describedby="alert-dialog-description"
				>
					<DialogTitle id="alert-dialog-title" sx={{
						display: "flex",
						alignItems: "start",
						gap: "8px",
						marginTop: "10px",
					}}>
						<InfoOutlined sx={{ color: '#008ad5', fontSize: '25px' }}
						/>
						{category == "trademark" ? "Trademark" : "Patent"} rules execution complete. View observations in Audit Reports.
					</DialogTitle>
					<DialogContent>
						<DialogContentText >
							<AuditResultCard
								ip={""}
								totalObservations={total_added}
								totalNewErrors={total_new_errors}
								totalDuplicatesRemoved={deleted_duplicate}
								totalUniqueErrors={total_new_errors - total_duplicate}
								totalIngoredErrors={total_ignored}
								totalCorrectedIdentified={total_duplicate}
							/>

							{/* 
						<ul style={{
							display: "flex",
							flexDirection: "column",
							gap: "5px",
							}}>
							{total_added ?
							<span
							style={{ color: "green" }}>
							{total_added == 1 ? "1 Total Observation" : `${total_added} Total Observations`}
								</span>
								: ""}
								
								{total_new_errors ?
								<span>
								{total_new_errors == 1 ? "1 new error found. " : `${total_new_errors} new errors found. `}
								</span>
								: ""}

								{total_duplicate ?
								<span
								style={{
										color: "gray",
										}}
								>
								{total_duplicate == 1 ? "1 error already marked as corrected reoccured." : `${total_duplicate} errors already marked as corrected reoccured. `}
								</span>
								: ""}
								
								{total_ignored ?
								<span
									style={{
										color: "red",
										}}
										>
										{total_ignored == 1 ? "1 error was auto-ignored. " : `${total_ignored} errors were auto-ignored. `}
										</span>
										: ""}
										
										{deleted_duplicate ?
										<span
										style={{
											color: "red",
									}}
								>
									{deleted_duplicate == 1 ? "1 duplicate error was deleted. " : `${deleted_duplicate} duplicate errors were deleted. `}
								</span>
								: ""}

								{total_unique_errors == 1 ? "1 unique error found. " : `${total_unique_errors} unique errors found. `}
								</ul> */}

						</DialogContentText>
					</DialogContent>
					<DialogActions>
						{switchToTm && (
							<Button
								onClick={() => {
									switchCategory("trademark");
									setIpActiveTab(3);
									setShowResultDialogueBox(false)
								}}
							>
								Run Trademarks Rules
							</Button>
						)}
						<Button
							variant="contained"
							onClick={() => {
								setShowResultDialogueBox(false)
								navigate("/drm/audit-result");
							}} autoFocus>
							View Results
						</Button>
					</DialogActions>
				</Dialog>
			}
			<CustomDialog open={dialogOpen} onClose={() => setDialogOpen(false)} {...dialogProps} />
		</div>
	);
};

MappedRules.propTypes = {
	setActiveTab: PropTypes.func.isRequired,
};

export default MappedRules;